import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';
import { AccessYourSuperApplicationsListModel } from 'src/app/model/access-your-super-applications.model';

export const RequestAction = createAction('[Access your super start component] get data', props<{ accountId: number }>());
export const ResponseAction = createAction('[Access your super start component] set data', props<{ payload: AccessYourSuperApplicationsListModel }>());

